import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { SessionService } from './session.service';

@Injectable()
export class AuthServiceTonic {
  loggedIn = false;
  tonicUrl: string;

  constructor(private readonly sessionService: SessionService) {

    let siteUrl = window.location.origin; //window.location.href;
    /* if (siteUrl.indexOf('#') > 0) {
      siteUrl = siteUrl.substr(0, window.location.href.indexOf('#'));
    } */

    this.tonicUrl = environment.tonicSettings.url;
  }


  beginLogin(): Promise<any> {
    let user = this.sessionService.getSession();
    if (!user) {
      this.tonicRedirect()
      return Promise.resolve(false);
    }

    return Promise.resolve(user);
    
  }

  tonicRedirect() {
    window.location.href = this.tonicUrl + '?REDIR=' + window.location.href;
  }

  finishLogin(): Promise<any> {
    let route = '';
    const tonicIndex = window.location.href.indexOf('tonic_id');
    if (tonicIndex !== -1) {
      let tokenVal = window.location.href.substr(tonicIndex + 9);
      if (tokenVal.indexOf('#') !== -1) {
        route = tokenVal.substr(tokenVal.indexOf('#'));
        tokenVal = tokenVal.substr(0, tokenVal.indexOf('#'));
      }
      if (tokenVal.indexOf('&') !== -1) {
        tokenVal = tokenVal.substr(0, tokenVal.indexOf('&'));
      }
      this.sessionService.setToken(tokenVal);
      window.location.href = window.location.href.substr(0, tonicIndex -1) + route;
      return Promise.resolve(this.sessionService.getSession());
    } else {
      return Promise.resolve(null);
    }
    
  }

  httpErrorCheck(error: HttpErrorResponse) {
    if (error.status === 401) {
      this.sessionService.setToken('');
      // this.tonicRedirect();
    }
  }
}
